import DailyVolume from './daily-volume';

export default DailyVolume;
